import pug from 'javascripts/notifications/templates/notifications_unavailable.jst.pug';
window.JST = window.JST || {};
window.JST['notifications/templates/notifications_unavailable'] = pug;
